import type { FC } from 'react';
import { useWebinarT } from '@/hooks/useWebinarT';

type SplashScreenProps = {
  label?: string;
  fullscreen?: boolean;
};

const SplashScreen: FC<SplashScreenProps> = ({ label, fullscreen = false }) => {
  const { t, ready } = useWebinarT('common');
  const text = label ?? (ready ? t('loading') : '');

  return (
    <div
      aria-live="polite"
      className={`
        bg-gradient-page-auth
        h-svh w-full
        flex items-center justify-center
        overflow-hidden
        ${fullscreen ? 'fixed inset-0 z-50' : 'relative'}
      `}
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="
            w-[400px] h-[400px]
            overflow-hidden
            animate-pulse
            grid place-items-center
            p-[10%]
          "
        >
          <img
            src="/assets/welya-splash.png"
            alt="welya"
            className="w-full h-full object-contain"
            draggable={false}
          />
        </div>

        <p className="text-sm text-white/80">{text}</p>
      </div>
    </div>
  );
};

export default SplashScreen;
